module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-gray@3x-19bbecdcdd9cd61fa2d57638496d3b92.png";